import { Card, styled, Box, Grid, IconButton } from '../../../base';
import { shouldForwardProp } from '@mui/system';

export const CardWrapper = styled(Card)(({ theme }) => ({
    padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center',
    height: '100%',
    width: '100%',
    shadow: 'none !important',
}));

export const ProgressBarWrapper = styled(Grid)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: 9,
    marginBottom: 2,
}));

export const RangeBarWrapper = styled('div')(() => ({
    width: '60%',
}));

export const ContactInfoGrid = styled(Grid)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    paddingBottom: theme.spacing(1),
}));

export const IconButtonsBox = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
}));

const customShouldForwardStyledIconButtonProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) && !['buttonColor'].includes(prop as string);

export const StyledIconButton = styled(IconButton, {
    shouldForwardProp: customShouldForwardStyledIconButtonProp,
})<{ buttonColor?: string }>(({ theme, buttonColor }) => ({
    border: `2px solid ${buttonColor}`,
    color: buttonColor ?? undefined,
    width: theme.spacing(5),
    height: theme.spacing(5),
    '&:hover': {
        backgroundColor: theme.palette.background.mainBackground,
        borderColor: buttonColor, // Background color on hover
    },
}));
